import React, { useState, useEffect } from "react";
import { useFetch} from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import InputField from "components/fields/InputField";


const OrganModal = ({ showModal, setModalState, refreshData, categoryData, setCategoryData }) => {
    const fetchWrapper = useFetch();
    const [errorMessages, setErrorMessages] = useState({});
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [formErrorData, setFormErrorData] = useState({});

    const handleInputChange = (event) => {
        errorMessages.message = "";
        setFormErrorData({});
        const { id, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    const setErrorForField = (field) => {
        setFormErrorData({ [field]: "error" });
    }

    const errors = {
        name: "Please enter valid N.Doc",
        apiError: "Something went wrong"
    };

    const validationRules = {
        name: {
            validate: (value) => value && value.length >= 3,
            message: errors.name,
        },
    };

    useEffect(() => {
        setExistingData(categoryData)
        if (showModal) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showModal, categoryData]);

    const setExistingData = (data) => {
        if (data !== null && data !== undefined && data.id != null) {
            setFormData(data)
        }
    }

    const handleCancel = () => {
        setCategoryData(null);
        setModalState(false);
    }

    const handleSubmit = () => {
        for (let field in validationRules) {
            const {validate, message} = validationRules[field];
            if (!validate(formData[field])) {
                setErrorMessages({name: field, message: message});
                setErrorForField(field);
                return;
            }
        }

        setLoading(true);
        const requestOptions = {
            method: categoryData != null && categoryData.id !== undefined ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem("token")
            },
            body: JSON.stringify(formData)
        };

        fetchWrapper(process.env.REACT_APP_API_URL + "/v1/configuration/employee-category", requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setLoading(false);
                if (data.responseInfo.status === "SUCCESS") {
                    setCategoryData(null);
                    refreshData();
                    setModalState(false);
                } else {
                    setErrorMessages({
                        name: "apiError",
                        message: errors.apiError,
                    });
                }
            });
    };


    return (
        <>
            {showModal ? (
                <>
                    <Loader show={loading} />
                    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
                        <div className="relative my-10 mx-auto w-full max-w-3xl sm:w-4/5 md:w-3/4 lg:w-2/3 xl:w-1/2">
                            <div className="relative font-normal flex flex-col rounded-lg border-0 bg-white text-navy-800 shadow-lg outline-none focus:outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white dark:shadow-none">

                                {/* Modal Header */}
                                <div className="flex items-start justify-between rounded-t border-b border-solid p-5 border-slate-200">
                                    <h4 className="text-3xl font-semibold">Adicionar/editar Categoria
                                    </h4>
                                </div>

                                {/* Modal Body */}
                                <div className="p-5 space-y-4" style={{ overflowY: "auto", maxHeight: "70vh" }}>
                                    <div className="text-red-500 min-h-[1.30rem]">{errorMessages.message}</div>

                                    {/* Row 1: Payment Date with Calendar Icon and Document Number */}
                                    <div className="flex space-x-4 items-start">
                                        {/* Payment Date Field */}
                                        <div className="w-full">
                                            <div className="relative">
                                                <InputField
                                                    variant="auth"
                                                    label="Nome do categoria"
                                                    id="name"
                                                    type="text"
                                                    state={formErrorData.name === "error" ? "error" : ""}
                                                    value={formData.name}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* Modal Footer */}
                                <div className="flex items-center justify-end p-5 border-t border-solid border-slate-200 rounded-b">
                                    <button
                                        onClick={handleCancel}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                        Cancelar
                                    </button>
                                    <button
                                        onClick={handleSubmit}
                                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ml-auto"
                                    >
                                        Salvar
                                    </button>
                                </div>
                            </div>
                        </div>


                    </div>



                    {/*overlay*/}
                    <div className="bg-black opacity-90 fixed inset-0 z-40 backdrop-blur-2xl backdrop-filter"></div>
                </>
            ) : null}
        </>
    );
};

export default OrganModal;
